import React, { useCallback } from "react";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import {
  StyledBox,
  StyledBoxDis,
  StyledBoxInner,
  StyledTypographyWel,
  StyleTypographyText,
} from "../../../pages/auth/reset-Password/style";
import theme from "../../../theme";
import { StyledBoxPad, } from "../../../pages/auth/sign-up/style";
import CustomInput from "../../common/input/CustomInput";
import CustomButton from "../../common/button/CustomButton";
import { RESET_PASSWORD } from "../../../actions/AuthActions";
import { useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";

const validationSchema = Yup.object({
  newPassword: Yup.string()
    .required("new password is required")
    .min(8, "Password must be at least 8 characters long")
    .matches(/[a-z]/, "Password must contain at least one lowercase letter")
    .matches(/[A-Z]/, "Password must contain at least one uppercase letter")
    .matches(/\d/, "Password must contain at least one number")
    .matches(
      /[@$!%*?&]/,
      "Password must contain at least one special character"
    ),

  confirmPassword: Yup.string()
    .oneOf([Yup.ref("newPassword"), null], "Passwords must match")
    .required("Confirm Password is required"),
});

const ResetPassword = () => {
  const dispatch = useDispatch();

  const queryParams = new URLSearchParams(useLocation().search);
  const token = queryParams.get("token");
  const name = queryParams.get("name");

  const ResetPassword = useCallback(
    (data) => {
      dispatch({
        type: RESET_PASSWORD,
        payload: {
          ...data,
        },
      });
    },
    [dispatch]
  );
  return (
    <StyledBox>
      <StyledBoxInner>
        <StyledTypographyWel>WELCOME BACK {name}</StyledTypographyWel>
        <StyleTypographyText>Reset Password your Account</StyleTypographyText>
        <Formik
          initialValues={{ newPassword: "", confirmPassword: "", token: token }}
          validationSchema={validationSchema}
          onSubmit={(values) => {
            ResetPassword({
              newPassword: values.newPassword,
              token: token,
            });
          }}
        >
          {({ errors, handleChange, handleBlur, values, touched }) => (
            <Form>
              <StyledBoxDis>
                <CustomInput
                  label="New Password"
                  name="newPassword"
                  type="password"
                  value={values.newPassword}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  error={touched.newPassword && errors.newPassword}
                  helperText={touched.newPassword && errors.newPassword}
                  autoComplete="current-password"
                />
                <CustomInput
                  label="Confirm Password"
                  name="confirmPassword"
                  type="password"
                  value={values.confirmPassword}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  error={touched.confirmPassword && errors.confirmPassword}
                  helperText={touched.confirmPassword && errors.confirmPassword}
                  autoComplete="current-password"
                />
                <StyledBoxPad>
                  <CustomButton
                    fontSize={theme.typography.regular.fontSize}
                    type="submit"
                    btnLabel="SUBMIT"
                    btntype={"primary"}
                    height="56px"
                  />
                </StyledBoxPad>
              </StyledBoxDis>
            </Form>
          )}
        </Formik>
      </StyledBoxInner>
    </StyledBox>
  );
};

export default ResetPassword;
